import React, {FC} from 'react';

import {Trans} from '../../../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {OkCancelDialog} from '../../../../../common/dialogs/okCancelDialog';

/*
 * Props.
 */

interface InviteDropdownCloseConfirmationProps {
  onOkClick: Handler;
  onRequestClose: Handler;
}

/*
 * Component.
 */

export const InviteDropdownCloseConfirmation: FC<InviteDropdownCloseConfirmationProps> = (props) => (
  <OkCancelDialog
    {...props}
    title={<Trans id="invite-closeconfirmation-title">Close invite</Trans>}
    okButtonLabel={<Trans id="invite-closeconfirmation-ok">Close</Trans>}
  >
    <Trans id="invite-closeconfirmation-content">
      Would you like to close the current invite?
      <br />
      The invite message will be lost.
      <br />
      This action cannot be undone.
    </Trans>
  </OkCancelDialog>
);
